const caliberCollator = new Intl.Collator('es', {
  numeric: true,
  sensitivity: 'base',
});

const numericCaliberPattern =
  /^\s*\d+(?:[.,]\d+)?(?:\s*(?:mm|\+|[-/]\s*\d+(?:[.,]\d+)?(?:\s*mm)?))?\s*$/i;

export const isNumericCaliberLabel = (label: string) =>
  numericCaliberPattern.test(label);

const getLeadingCaliberNumber = (label: string) => {
  const match = /^\s*(\d+(?:[.,]\d+)?)/.exec(label);
  return match ? Number(match[1].replace(',', '.')) : null;
};

/** Numeric calibers first and ascending; named labels use natural ordering. */
export const compareCaliberLabelsAscending = (left: string, right: string) => {
  const leftIsNumeric = isNumericCaliberLabel(left);
  const rightIsNumeric = isNumericCaliberLabel(right);

  if (leftIsNumeric && rightIsNumeric) {
    const numericDifference =
      getLeadingCaliberNumber(left)! - getLeadingCaliberNumber(right)!;
    if (numericDifference !== 0) return numericDifference;
  } else if (leftIsNumeric !== rightIsNumeric) {
    return leftIsNumeric ? -1 : 1;
  }

  return caliberCollator.compare(left, right);
};

/** Preserve the shipment summary's cherry scale after numeric/other labels. */
export const compareShipmentCalibersAscending = (
  left: string,
  right: string,
  speciesId?: number
) => {
  if (speciesId === 2) {
    const scale = ['L', 'XL', 'J', '2J', '3J', '4J', '5J', '6J'];
    const leftRank = scale.indexOf(left.trim().toUpperCase());
    const rightRank = scale.indexOf(right.trim().toUpperCase());
    if (leftRank !== -1 || rightRank !== -1) {
      return leftRank - rightRank;
    }
  }
  return compareCaliberLabelsAscending(left, right);
};
